export const setLoader = loader => ({
  type: 'LOADER',
  loader,
});
